import React from 'react';
import { mui } from '@local/finsera-core/src/libs';

export const FinDataGridColumnsDialog = React.memo(function FinDataGridColumnsDialog() {
  const apiRef = mui.dataGrid.useGridApiContext();

  const handleClose = React.useCallback(() => {
    apiRef.current.hidePreferences();
  }, [apiRef]);

  return (
    <mui.core.Dialog
      open
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      hideBackdrop
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
        },
      }}
    >
      <mui.core.DialogTitle sx={{ pb: 2, px: 4, pt: 4 }}>Manage columns</mui.core.DialogTitle>

      <mui.core.DialogContent
        sx={{
          px: 4,
          pb: 4,
          pt: 3,

          '.MuiDataGrid-panelContent': {
            padding: 0,
            maxWidth: '100%',
          },

          // extra breathing room before the columns content/search
          '.MuiDataGrid-columnsPanel': {
            mt: 3,
          },
        }}
      >
        <mui.dataGrid.GridColumnsPanel />
      </mui.core.DialogContent>
    </mui.core.Dialog>
  );
});
